(() => {
  if (window.kindgutUsageEditorReady) return;
  window.kindgutUsageEditorReady = true;
  document.addEventListener('click', event => {
    const open = event.target.closest('[data-kg-usage-open]');
    if (open) {
      const root = open.closest('[data-pc-bp]');
      const modal = root?.querySelector('[data-kg-usage-modal]');
      if (modal && !modal.open) {
        modal._kindgutOpener = open;
        modal.showModal();
      }
    }
    const close = event.target.closest('[data-kg-usage-close]');
    if (close) close.closest('dialog')?.close();
    if (event.target.matches('[data-kg-usage-modal]')) {
      const box = event.target.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) event.target.close();
    }
  });
  document.addEventListener('close', event => {
    if (event.target.matches('[data-kg-usage-modal]')) event.target._kindgutOpener?.focus({ preventScroll: true });
  }, true);
  document.addEventListener('shopify:section:select', event => { const modal=event.target.querySelector('[data-kg-usage-modal]');if(modal&&!modal.open)modal.showModal(); });
  document.addEventListener('shopify:section:deselect', event => event.target.querySelector('[data-kg-usage-modal][open]')?.close());
  document.addEventListener('shopify:section:unload', event => event.target.querySelector('[data-kg-usage-modal][open]')?.close());
})();
